import Main from '@/views/administracion/reportes/contrato/Main.vue';
import DefaultContrato from '@/views/administracion/contratos/contrato/Default.vue';
import MainAnticipos from '@/views/administracion/contratos/contrato/anticipos/Main.vue';
import MainConvenios from '@/views/administracion/contratos/contrato/convenios/Main.vue';
import MainPrograma from '@/views/administracion/contratos/contrato/programa/Main.vue';
import MainCatalogo from '@/views/administracion/contratos/contrato/catalogo/Main.vue';
import MainContratoReporteFisico from '@/views/administracion/ejecucion/contrato/reportes/Main.vue';
import MainEstimaciones from '@/views/administracion/ejecucion/contrato/estimaciones/Default.vue';
// import MainAlbum from '@/views/administracion/ejecucion/contrato/album/Main.vue';
import MainAlbumFrentes from '@/views/administracion/reportes/contrato/albumFrentes/Main.vue';
import MainFianzas from '@/views/administracion/contratos/contrato/fianzas/Main.vue';
import MainActividades from '@/views/administracion/contratos/contrato/actividades/Main.vue';
import MainExpediente from '@/views/administracion/contratos/contrato/expediente/Main.vue';
import MainGraficaAvanceFisico from '@/views/administracion/reportes/contrato/graficaavancefisico/Main.vue';
import MainContratoCatalogoFavoritos from '@/views/administracion/ejecucion/contrato/catalogofavoritos/Default.vue';
import MainContratoVideos from '@/views/administracion/contratos/contrato/contratovideos/Main.vue';
import MainAvancesExpediente from '@/views/administracion/reportes/contrato/avancesExpediente/Main.vue';

const auth = ['Contratos:ver', 'Consultas:ver'];
const scopes = ['Contratos:crear', 'Contratos:editar', 'Contratos:eliminar'];

const contrato = [
  {
    path: 'contrato/:idContrato',
    meta: {
      title: 'Contrato',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'consultasContratoDefault',
        path: '/',
        meta: {
          title: 'Generales',
          auth,
          scopes,
        },
        props: {
          soloLectura: true,
        },
        component: DefaultContrato,
      },
      {
        name: 'consultasContratoAnticipos',
        path: 'anticipos',
        meta: {
          title: 'Anticipos',
          auth: ['Contratos:ver'],
          scopes,
        },
        props: {
          soloLectura: true,
        },
        component: MainAnticipos,
      },
      {
        name: 'consultasContratoConveniosModificatorios',
        path: 'convenios',
        meta: {
          title: 'Convenios modificatorios',
          auth: ['Contratos:ver'],
          scopes,
        },
        props: {
          soloLectura: true,
        },
        component: MainConvenios,
      },
      {
        name: 'consultasContratoPrograma',
        path: 'programa',
        meta: {
          title: 'Programa',
          auth: ['Contratos:ver'],
          scopes,
        },
        props: {
          soloLectura: true,
        },
        component: MainPrograma,
      },
      {
        name: 'consultasContratoCatalogo',
        path: 'catalogo',
        meta: {
          title: 'Catálogo',
          auth: ['Contratos:ver'],
          scopes,
        },
        props: {
          soloLectura: true,
        },
        component: MainCatalogo,
      },
      {
        name: 'consultasContratoEjecucionReportes',
        path: 'reportes',
        meta: {
          title: 'Contrato',
          auth,
          scopes,
        },
        component: MainContratoReporteFisico,
      },
      {
        name: 'consultasContratoEjecucionEstimaciones',
        path: 'estimaciones',
        meta: {
          title: 'Contrato',
          auth: ['Contratos:ver'],
          scopes,
        },
        component: MainEstimaciones,
        props: {
          soloLectura: true,
        },
      },
      {
        name: 'consultasContratoAlbumFrentes',
        path: 'albumfrentes',
        meta: {
          title: 'Album Fotográfico',
          auth,
          scopes,
        },
        component: MainAlbumFrentes,
        /*
        props: {
          modulo: 'consultas',
        }, */
      },
      {
        name: 'consultasContratoFianzas',
        path: 'fianzas',
        meta: {
          title: 'Fianzas',
          auth: ['Contratos:ver'],
          scopes,
        },
        component: MainFianzas,
      },
      {
        name: 'consultasContratoActividades',
        path: 'actividades',
        meta: {
          title: 'Actividades',
          auth: ['Contratos:ver'],
          scopes,
        },
        component: MainActividades,
      },
      {
        name: 'consultasContratoExpediente',
        path: 'expediente',
        meta: {
          title: 'Expediente',
          auth,
          scopes,
        },
        component: MainExpediente,
        props: {
          soloLectura: true,
        },
      },
      {
        name: 'consultaContratoGraficaAvanceFisico',
        path: 'grafica-avance-fisico',
        meta: {
          title: 'GraficaAvanceFisico',
          auth,
          scopes,
        },
        component: MainGraficaAvanceFisico,
      },
      {
        name: 'consultaContratoActiviodadesPrincipales',
        path: 'actividadesprincipales',
        meta: {
          title: 'Actividades principales',
          auth,
          scopes,
        },
        component: MainContratoCatalogoFavoritos,
      },
      {
        name: 'consultaContratoVideos',
        path: 'consulta-videos',
        meta: {
          title: 'Consulta-Videos',
          auth,
          scopes,
        },
        component: MainContratoVideos,
        props: {
          soloLectura: true,
        },
      },
      {
        name: 'consultaContratoAvancesExpediente',
        path: 'consulta-avances',
        meta: {
          title: 'Consulta-Avances',
          auth,
          scopes,
        },
        component: MainAvancesExpediente,
      },
    ],
  },
];

export default contrato;
